import {loadingSlice} from "./loadingSlice";

const {actions} = loadingSlice;

export const showLoading = url => dispatch => {
  dispatch(actions.startCall({url}));
};

export const hiddeLoading = url => dispatch => {
  dispatch(actions.endCall({url}));
};





